module.exports = __webpack_public_path__ + "media/src/images/top_covers/2021_jan_02-eb86868bdefa33a1b48c3eb3c3158f58.png";